import * as React from 'react';
import { AuthService } from '../AuthService';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IFetchDefault } from 'redux/modules/fetch';
import { AuthContext } from 'helpers/authcontext';

export const AuthConsumer = AuthContext.Consumer;

interface IProps {
	fetchDefault?: IFetchDefault;
	dispatch?: any;
}

@connect(
	(state: IStore) => ({
		fetchDefault: state.fetchDefault,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
export class AuthProvider extends React.Component<IProps, {}> {
	private authService;
	constructor(props) {
		super(props);
		this.authService = new AuthService();
	}

	public componentDidMount() {
		this.authService.setFetchDefault(this.props.dispatch);
	}

	public render() {
		return <AuthContext.Provider value={this.authService}>{this.props.children}</AuthContext.Provider>;
	}
}
